import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";
import { Order } from "../entity/ShopEntity";

export class OrderService extends BaseService {
    public action(
        api: string,
        order: Order,
        success: Success,
        failure?: Failure
      ) {
        super.post(api, order).then(
          function (result) {
            success(result);
          },
          function (error: Error) {
            if (failure) {
              failure(error);
            }
          }
        );
      } 
}
